import { ChevronLeft } from "lucide-react";
import FleetOwnerPayoutRecords from "../../../components/request/FleetOwnerPayoutRecords";
import { Button } from "../../../components/ui/button";


export default function SysPayoutRequests() {
    return (
      <div className="bg-white">
        <div className="flex items-center justify-between">
          <div className="my-8">
            <h1 className="text-lg mb-0 flex items-center gap-2 font-bold">
              <Button variant="ghost" className="text-blue-600" onClick={() => window.history.back()}>
                <ChevronLeft className="text-lg" />
                <span className="font-bold">Back</span>
              </Button>
            </h1>
          </div>
        </div>
        <FleetOwnerPayoutRecords />
      </div>        
    );
}